export default __webpack_public_path__ + "static/aid_character_hat-97fde09a91accba7e158b1d6209a9e1c.svg";